<template>
<tr>
  <template v-if="isEdit">
    <td class="text-center"><span class="ellipsis-2line">{{ courseData.name }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ courseData.holeTotal }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ courseData.par }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ courseData.courseType }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ courseData.courseArchitect }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ courseData.openDate }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ formatTextPolicy(courseData.guestPolicy) }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ formatMoney(courseData.weekdayPrice) }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ formatMoney(courseData.weekendPrice) }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ formatMoney(courseData.twilightPrice) }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ courseData.fairway }}</span></td>
    <td class="text-center"><span class="ellipsis-2line">{{ courseData.green }}</span></td>
    <td class="white" v-if="isCourseAdmin">
      <ButtonEdit
        :text="$gettext('Edit')"
        @click="isEdit = !isEdit"
      />
    </td>
  </template>
  <template v-else>
    <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.name" class="white--text"></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.holeTotal"></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.par"></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.courseType"></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.courseArchitect"></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.openDate"></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.guestPolicy"></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.weekdayPrice"></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.weekendPrice"></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.twilightPrice"></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.fairway" ></v-text-field>
  </td>
  <td class="text-center">
    <v-text-field outlined height="34" hide-details v-model="courseData.green"></v-text-field>
  </td>
  <td class="d-flex flex-row white px-1">
    <v-btn
    text
    @click="cancel"
    class="font-weight-bold elevation-0 text-none body-2 mr-2 px-2"
  >
    <translate>Cancel</translate>
  </v-btn>
  <v-btn
    text
    type="submit"
    color="primary"
    @click="onSubmit"
    class="font-weight-bold elevation-0 text-none body-2 px-2"
  >
    <translate>Save</translate>
  </v-btn>
    </td>
  </template>
</tr>
</template>

<script>
import ButtonEdit from "@/components/Buttons/ButtonEdit";
import { formatNumberMoney } from "@/utils/helper";
export default {
  name: 'TableColumn',
  components: {ButtonEdit},
  props: {
    course: {type: Object, default: {}},
    isCourseAdmin: {type: Boolean, default: false}
  },
  data() {
    return {
      isEdit: true,
      courseData: {},
      dataSuccess: {}
    };
  },
  computed: {
    courseDetail() {
      return this.$store.state.golfcourse.courseDetail;
    },
  },
  methods: {
    async onSubmit() {
      const data = this.courseData
      data.course = this.courseDetail.id,
      data.id = data.id,
      data.name = data.name
      const result = await this.$store.dispatch('updateCoursePeers', data)
      if (result.error) {
        this.$toast.alert(result.error.message);
      } else {
        // this.course = this.courseData
        const text = this.$gettext('Update success')
        this.$toast.success(text);
        this.dataSuccess =  result
      }
        this.isEdit = !this.isEdit
    },
    cancel() {
      if(Object.keys(this.dataSuccess).length == 0) {
        this.courseData = Object.assign({}, this.course)
      } else {
        this.courseData = Object.assign({}, this.dataSuccess)
      }
      this.isEdit = !this.isEdit
    },
    formatMoney(number) {
      if(number && (typeof number == 'number')) {
        return formatNumberMoney(number)
      } else '0'
    },
    formatTextPolicy(text) {
      if(text == 'open' || text == 'Open') {
        return this.$gettext('Open')
      } else text
    }
  },
  created() {
    this.courseData = Object.assign({}, this.course)
  }
};
</script>
